import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2015", value: 13.9 },
  { name: "2016", value: 15 },
  { name: "2017", value: 16.4 },
  { name: "2018", value: 17.8 },
  { name: "2019", value: 19.4 },
  { name: "2020", value: 21.2 },
  { name: "2021", value: 23.2 },
  { name: "2022", value: 25.4 },
  { name: "2023", value: 27.9 },
  { name: "2024", value: 30.9 },
  { name: "2025", value: 34.2 },
];

const renderCustomTooltip = ({ payload }) => {
  if (payload && payload.length > 0) {
    const dataPoint = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p>{dataPoint.name}</p>
        <p
          style={{ color: "rgb(53, 162, 235)" }}
        >{`Number of global active device connections in billions: ${dataPoint.value}`}</p>
      </div>
    );
  }
  return null;
};

const ConnectedDevicesChartRe = () => {
  return (
    <div>
      <p style={{ textAlign: "center", marginBottom: "5px", fontSize: "14px" }}>
        Number of global active device connections in billions
        <sup style={{ fontSize: "10px" }}>1</sup>
      </p>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          {/* <Tooltip content={renderCustomTooltip} /> */}
          <Tooltip />
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="rgb(53, 162, 235)"
            animationBegin={500}
            animationDuration={1000}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ConnectedDevicesChartRe;
